import _constants2 from "./constants";
import _EAN4 from "./EAN";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);
  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);
    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;
    if (getter === undefined) {
      return undefined;
    }
    return getter.call(receiver);
  }
};
var _constants = _constants2;
var _EAN2 = _EAN4;
var _EAN3 = _interopRequireDefault(_EAN2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Encoding documentation:
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Binary_encoding_of_data_digits_into_EAN-13_barcode

// Calculate the checksum digit
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Calculation_of_checksum_digit
var checksum = function checksum(number) {
  var res = number.substr(0, 12).split("").map(function (n) {
    return +n;
  }).reduce(function (sum, a, idx) {
    return idx % 2 ? sum + a * 3 : sum + a;
  }, 0);
  return (10 - res % 10) % 10;
};
var EAN13 = function (_EAN) {
  _inherits(EAN13, _EAN);
  function EAN13(data, options) {
    _classCallCheck(this, EAN13);

    // Add checksum if it does not exist
    if (data.search(/^[0-9]{12}$/) !== -1) {
      data += checksum(data);
    }

    // Adds a last character to the end of the barcode
    var _this = _possibleConstructorReturn(this, (EAN13.__proto__ || Object.getPrototypeOf(EAN13)).call(this, data, options));
    _this.lastChar = options.lastChar;
    return _this;
  }
  _createClass(EAN13, [{
    key: "valid",
    value: function valid() {
      return this.data.search(/^[0-9]{13}$/) !== -1 && +this.data[12] === checksum(this.data);
    }
  }, {
    key: "leftText",
    value: function leftText() {
      return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), "leftText", this).call(this, 1, 6);
    }
  }, {
    key: "leftEncode",
    value: function leftEncode() {
      var data = this.data.substr(1, 6);
      var structure = _constants.EAN13_STRUCTURE[this.data[0]];
      return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), "leftEncode", this).call(this, data, structure);
    }
  }, {
    key: "rightText",
    value: function rightText() {
      return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), "rightText", this).call(this, 7, 6);
    }
  }, {
    key: "rightEncode",
    value: function rightEncode() {
      var data = this.data.substr(7, 6);
      return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), "rightEncode", this).call(this, data, "RRRRRR");
    }

    // The "standard" way of printing EAN13 barcodes with guard bars
  }, {
    key: "encodeGuarded",
    value: function encodeGuarded() {
      var data = _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), "encodeGuarded", this).call(this);

      // Extend data with left digit & last character
      if (this.options.displayValue) {
        data.unshift({
          data: "000000000000",
          text: this.text.substr(0, 1),
          options: {
            textAlign: "left",
            fontSize: this.fontSize
          }
        });
        if (this.options.lastChar) {
          data.push({
            data: "00"
          });
          data.push({
            data: "00000",
            text: this.options.lastChar,
            options: {
              fontSize: this.fontSize
            }
          });
        }
      }
      return data;
    }
  }]);
  return EAN13;
}(_EAN3.default);
exports.default = EAN13;
export default exports;